(function () {
  const STORAGE_KEY_FIRST = "mycare_first_attribution";
  const STORAGE_KEY_LAST = "mycare_last_attribution";

  const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
  ];

  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const data = {};

    UTM_KEYS.forEach((key) => {
      data[key] = params.get(key) || "";
    });

    return data;
  }

  function getRefSource() {
    const ref = document.referrer || "";

    if (!ref) return "direct";

    try {
      const refHost = new URL(ref).hostname.replace("www.", "");
      const currentHost = window.location.hostname.replace("www.", "");

      if (refHost === currentHost) return "internal";

      if (refHost.includes("instagram")) return "instagram";
      if (refHost.includes("facebook")) return "facebook";
      if (refHost.includes("google")) return "google";
      if (refHost.includes("chatgpt") || refHost.includes("openai")) return "chatgpt";
      if (refHost.includes("whatsapp")) return "whatsapp";
      if (refHost.includes("tiktok")) return "tiktok";
      if (refHost.includes("linkedin")) return "linkedin";

      return refHost;
    } catch (e) {
      return "unknown";
    }
  }

  function getLeadSource(utmSource, refSource) {
    if (utmSource) return utmSource;
    if (refSource && refSource !== "internal") return refSource;
    return "direct";
  }

  function buildAttribution() {
    const utm = getUrlParams();
    const refSource = getRefSource();
    const leadSource = getLeadSource(utm.utm_source, refSource);

    return {
      lead_source: leadSource,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_content: utm.utm_content,
      utm_term: utm.utm_term,
      ref_source: refSource,
      referrer: document.referrer || "",
      landing_page: window.location.href,
      page_url: window.location.href,
      page_title: document.title || "",
      timestamp: new Date().toISOString()
    };
  }

  function saveAttribution() {
    const current = buildAttribution();

    try {
      const firstSaved = localStorage.getItem(STORAGE_KEY_FIRST);

      if (!firstSaved) {
        localStorage.setItem(STORAGE_KEY_FIRST, JSON.stringify(current));
      }

      localStorage.setItem(STORAGE_KEY_LAST, JSON.stringify(current));
    } catch (e) {
      // localStorage may be blocked. Continue silently.
    }

    return current;
  }

  function getStoredAttribution() {
    let first = {};
    let last = {};

    try {
      first = JSON.parse(localStorage.getItem(STORAGE_KEY_FIRST) || "{}");
      last = JSON.parse(localStorage.getItem(STORAGE_KEY_LAST) || "{}");
    } catch (e) {}

    const fallback = buildAttribution();

    return {
      lead_source: first.lead_source || last.lead_source || fallback.lead_source,
      utm_source: first.utm_source || last.utm_source || fallback.utm_source,
      utm_medium: first.utm_medium || last.utm_medium || fallback.utm_medium,
      utm_campaign: first.utm_campaign || last.utm_campaign || fallback.utm_campaign,
      utm_content: first.utm_content || last.utm_content || fallback.utm_content,
      utm_term: first.utm_term || last.utm_term || fallback.utm_term,
      ref_source: first.ref_source || last.ref_source || fallback.ref_source,
      referrer: first.referrer || last.referrer || fallback.referrer,
      landing_page: first.landing_page || last.landing_page || fallback.landing_page,
      page_url: window.location.href,
      page_title: document.title || "",
      first_touch_timestamp: first.timestamp || "",
      last_touch_timestamp: last.timestamp || fallback.timestamp
    };
  }

  function setFieldValue(form, key, value) {
    const selectors = [
      `[data-mycare-field="${key}"]`,
      `input[name="${key}"]`,
      `input[name="contact[${key}]"]`,
      `textarea[name="${key}"]`,
      `textarea[name="contact[${key}]"]`
    ];

    selectors.forEach((selector) => {
      form.querySelectorAll(selector).forEach((field) => {
        field.value = value || "";
      });
    });
  }

  function fillForms() {
    const attribution = getStoredAttribution();

    document.querySelectorAll("form").forEach((form) => {
      Object.keys(attribution).forEach((key) => {
        setFieldValue(form, key, attribution[key]);
      });
    });
  }

  saveAttribution();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fillForms);
  } else {
    fillForms();
  }

  document.addEventListener("shopify:section:load", fillForms);

  const observer = new MutationObserver(function () {
    fillForms();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
/* =========================================================
   MyCare Form Tracking Helper
   Tracks original source, first landing page, session journey
========================================================= */

(function () {
  if (window.MyCareFormTracking) return;

  var STORAGE_PREFIX = 'mycare_track_';
  var PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'ref',
    'ref_source',
    'source'
  ];

  function safeGetStorage(key) {
    try {
      return localStorage.getItem(STORAGE_PREFIX + key) || sessionStorage.getItem(STORAGE_PREFIX + key) || '';
    } catch (e) {
      return '';
    }
  }

  function safeSetStorage(key, value) {
    if (!value) return;

    try {
      localStorage.setItem(STORAGE_PREFIX + key, value);
      sessionStorage.setItem(STORAGE_PREFIX + key, value);
    } catch (e) {}
  }

  function getParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function initTracking() {
    var currentUrl = window.location.href;
    var currentPath = window.location.pathname + window.location.search;

    if (!safeGetStorage('first_landing_page')) {
      safeSetStorage('first_landing_page', currentUrl);
    }

    if (!safeGetStorage('session_entry_page')) {
      safeSetStorage('session_entry_page', currentUrl);
    }

    if (!safeGetStorage('first_referrer') && document.referrer) {
      safeSetStorage('first_referrer', document.referrer);
    }

    PARAMS.forEach(function (param) {
      var value = getParam(param);
      if (value && !safeGetStorage(param)) {
        safeSetStorage(param, value);
      }
    });

    var journey = safeGetStorage('user_journey');

    if (!journey) {
      safeSetStorage('user_journey', currentPath);
    } else {
      var parts = journey.split(' > ');
      var last = parts[parts.length - 1];

      if (last !== currentPath) {
        parts.push(currentPath);

        if (parts.length > 12) {
          parts = parts.slice(parts.length - 12);
        }

        safeSetStorage('user_journey', parts.join(' > '));
      }
    }
  }

  function getTrackingData(extra) {
    initTracking();

    var data = {
      'Submitted At': new Date().toISOString(),

      'Form Type': extra && extra.formType ? extra.formType : '',
      'Service Context': extra && extra.serviceContext ? extra.serviceContext : '',
      'Lead Source': extra && extra.leadSource ? extra.leadSource : 'Website',

      'Page Title': document.title || '',
      'Page URL': window.location.href,
      'Landing Page': window.location.origin + window.location.pathname,
      'First Landing Page': safeGetStorage('first_landing_page'),
      'Session Entry Page': safeGetStorage('session_entry_page'),

      'Referrer': document.referrer || '',
      'First Referrer': safeGetStorage('first_referrer'),

      'UTM Source': getParam('utm_source') || safeGetStorage('utm_source'),
      'UTM Medium': getParam('utm_medium') || safeGetStorage('utm_medium'),
      'UTM Campaign': getParam('utm_campaign') || safeGetStorage('utm_campaign'),
      'UTM Content': getParam('utm_content') || safeGetStorage('utm_content'),
      'UTM Term': getParam('utm_term') || safeGetStorage('utm_term'),

      'Ref Source':
        getParam('ref') ||
        getParam('ref_source') ||
        getParam('source') ||
        safeGetStorage('ref') ||
        safeGetStorage('ref_source') ||
        safeGetStorage('source'),

      'User Journey': safeGetStorage('user_journey'),
      'User Agent': navigator.userAgent || ''
    };

    return data;
  }

  function appendToFormData(formData, extra) {
    var tracking = getTrackingData(extra);

    Object.keys(tracking).forEach(function (key) {
      if (!formData.has(key) || !formData.get(key)) {
        formData.set(key, tracking[key]);
      }
    });

    return formData;
  }

  function appendToParams(params, extra) {
    var tracking = getTrackingData(extra);

    Object.keys(tracking).forEach(function (key) {
      if (!params.has(key) || !params.get(key)) {
        params.set(key, tracking[key]);
      }
    });

    return params;
  }

  function appendToObject(obj, extra) {
    var tracking = getTrackingData(extra);

    Object.keys(tracking).forEach(function (key) {
      if (!obj[key]) {
        obj[key] = tracking[key];
      }
    });

    return obj;
  }

  window.MyCareFormTracking = {
    init: initTracking,
    get: getTrackingData,
    appendToFormData: appendToFormData,
    appendToParams: appendToParams,
    appendToObject: appendToObject
  };

  initTracking();
})();